import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { pridictionorder } from "../../../actions/orderAction";
import { withRouter } from "react-router-dom";
import $ from 'jquery';
import * as myConstList from '../../../BaseUrl';
import { toast, Toaster } from 'react-hot-toast';
import moment from 'moment';
import { socket } from 'socket.io';
import socketIOClient from "socket.io-client";
const baseUrl = myConstList.baseUrl;

const jwtToken = localStorage.getItem("jwtToken");
const toastStyles = {
  style: {
    borderRadius: '10px',
    background: '#fff',
    color: '#000',
  },
}
class PredictionBuyOrder extends React.Component {
  constructor(props) {
    super(props);
    const { user } = this.props.auth;
    this.state = {
      user_id: this.props.user_id,
      bprice: this.props.currentprice < 0.0001 && this.props.currentprice > 0.000001 ? parseFloat(this.props.currentprice).toFixed(8) : this.props.currentprice < 0.1 && this.props.currentprice > 0.0001 ? parseFloat(this.props.currentprice).toFixed(6) : this.props.currentprice < 1 && this.props.currentprice > 0.1 ? parseFloat(this.props.currentprice).toFixed(4) : this.props.currentprice > 1 ? parseFloat(this.props.currentprice).toFixed(2) : parseFloat(this.props.currentprice).toFixed(2), bamount: "",
      message: "",
      usdt: this.props.usdt,
      btotal: "",
      btnDisable: false,
      contestName: "",
      errors: {},
      // Buy:"Active",
      orderTypeText: false,
      stopLoss:0,
      updatedMarketPrice:0,
      limitBuy:'active',
      pridictionUserPrice:"",
      pridicationBidType:"",
      contestType:this.props.contestData.contestType,
      orderPredictionData:[],
      endDate:this.props.contestData.endDate,
      startDate:this.props.startDate,
      priceDistributionDateTime:this.props.contestData.priceDistributionDateTime,
      disableModifyButton:this.props.disableModifyButton,    
      timeRemainingdays:this.props.timeRemainingdays,
      timeRemainingHours:this.props.timeRemainingHours,
      timeRemainingMinutes:this.props.timeRemainingMinutes,
      timeRemainingSeconds:this.props.timeRemainingSeconds,  
    };
  }
  componentWillReceiveProps(nextProps) {    
    // console.log("currentpricecurrentprice==",nextProps.disableModifyButton);
    if (nextProps.currentprice != undefined) {
      const convrtprice = nextProps.currentprice < 0.0001 && nextProps.currentprice > 0.000001 ? parseFloat(nextProps.currentprice).toFixed(8) : nextProps.currentprice < 0.1 && nextProps.currentprice > 0.0001 ? parseFloat(nextProps.currentprice).toFixed(6) : nextProps.currentprice < 1 && nextProps.currentprice > 0.1 ? parseFloat(nextProps.currentprice).toFixed(4) : nextProps.currentprice > 1 ? parseFloat(nextProps.currentprice).toFixed(2) : parseFloat(nextProps.currentprice).toFixed(2);
      
      this.setState({
          bprice: convrtprice,
        });
    }
    if(nextProps.timeRemainingdays !=undefined){
      this.setState({
        timeRemainingdays:this.props.timeRemainingdays,
        timeRemainingHours:this.props.timeRemainingHours,
        timeRemainingMinutes:this.props.timeRemainingMinutes,
        timeRemainingSeconds:this.props.timeRemainingSeconds,  
      });
    }
    // console.log("nextProps.orderPredictionDatanextProps.orderPredictionData=",nextProps.orderPredictionData);
    if (nextProps.orderPredictionData != undefined) {
      // console.log("nextProps.orderPredictionDatanextProps.orderPredictionData=",nextProps.orderPredictionData);
      this.setState({
        orderPredictionData: nextProps.orderPredictionData
      });
    }
    if (nextProps.usdt != undefined) {
      this.setState({
        usdt: nextProps.usdt
      });
    }
    if (nextProps.user_id) {
      this.setState({
        user_id: nextProps.user_id
      });
    }
    if(nextProps.contestData.contestType != undefined) {
      this.setState({
        contestType: nextProps.contestData.contestType
      });
    }
    if(nextProps.disableModifyButton != undefined) {
      this.setState({
        disableModifyButton:nextProps.disableModifyButton
      });
    }
    if (nextProps.contestData.contestName != undefined) {
      this.setState({
        contestName: nextProps.contestData.contestName,
        priceDistributionDateTime:nextProps.contestData.priceDistributionDateTime,
        endDate:nextProps.contestData.endDate,
        
      });
    }
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
    if (nextProps.orderdata !== undefined
      && nextProps.orderdata.order !== undefined
      && nextProps.orderdata.order.data !== undefined
      && nextProps.orderdata.order.data.message !== undefined) {
      let mainSymbol = this.props.match.params.symbol.replace("-", "");
      let exchangeType = this.props.match.params.exchangetype;
      fetch(`${baseUrl}api/crpto-price?symbol=${mainSymbol}&&exchnageType=${exchangeType}`)
        .then(response => response.json())
        .then(response => {
          nextProps.orderdata.order.data.message = "";
          // console.log("responsePrice==",nextProps.orderdata.order.data.message);
          const convrtprice = response.price < 0.0001 && response.price > 0.000001 ? parseFloat(response.price).toFixed(8) : response.price < 0.1 && response.price > 0.0001 ? parseFloat(response.price).toFixed(6) : response.price < 1 && response.price > 0.1 ? parseFloat(response.price).toFixed(4) : response.price > 1 ? parseFloat(response.price).toFixed(2) : parseFloat(response.price).toFixed(2);
          
          // this.setState({bprice:convrtprice});
        })
        .catch();      
    }
  }
  onChange = e => {
    // e.preventDefault();
   
    // let val = e.target.value;
    // val = val.replace(/([^0-9.]+)/, "");
    // // val = val.replace(/^(0|\.)/, "");
    // const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val);
    // const value = match[1] + match[2];
    // e.target.value = value;
    // this.setState({ bamount: value });
    // if (val.length > 0) {
    //   e.target.value = Number(value).toFixed(2);
    //   this.setState({ bamount: Number(value).toFixed(2) });
    // }
    this.setState({ message: "", errors: {} });    
    if (e.target.id === 'pridictionUserPrice') {
      this.setState({ pridictionUserPrice: e.target.value });
    }
  };
  downBid = e => {
    this.setState({ pridicationBidType: 'down' });
  }
  upBid = e => {
    this.setState({ pridicationBidType: 'up' });
  }
  handleKeyDown = event => {
    if (event.keyCode === 38 || event.keyCode === 40) {
      event.preventDefault();
    }
  };
  addQuantity =(percentageValue)=>{    
    let currntBalance = this.state.usdt;   
    // let totalAmount = exactQuatity*this.state.bprice;
    // this.state.bprice
    // var btotal = (this.state.bprice * e.target.value).toFixed(2);
    // this.setState({ bamount: exactQuatity, btotal: totalAmount });
  }

  onOrderUpdate = e => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    const { user } = this.props.auth;
    let exchangeType = this.props.match.params.exchangetype.toLowerCase();    
    console.log("VB===",this.state.timeRemainingdays,this.state.timeRemainingHours,this.state.timeRemainingMinutes,this.state.timeRemainingSeconds);
    if(this.state.timeRemainingdays <= 0 && this.state.timeRemainingHours <= 0 && this.state.timeRemainingMinutes <= 0 && this.state.timeRemainingSeconds <= 0){
      toast.error("Your Contest timeout", toastStyles);  
      return false;
    }
      const newOrder = {
        user_id: user.id,
        contest_id: this.props.match.params.id,
        marketPrice: this.state.bprice,
        coinName: this.props.match.params.symbol.replace("-", "").slice(0, -4),
        exchange_type: exchangeType,
        pridictionUserPrice: this.state.pridictionUserPrice,
        contestType:this.state.contestType,
        bidType:this.state.pridicationBidType,        
      };
      // console.log("newOrder==",newOrder);
      this.props.pridictionorder(newOrder);
      this.setState({
        pridictionUserPrice: "",
      });
      const socket = socketIOClient(baseUrl, { query: "jwtToken=" + jwtToken + "&contestId=" + this.props.match.params.id + "&symbol=" + this.props.match.params.symbol + "&exchangetype=" + exchangeType + "&&contestType="+this.state.contestType });
      socket.on("connect", () => {
        socket.emit("orderUpdateApiCall");
      })
  };
  
  render() {
    if (this.state.bprice != undefined) {
      var pricess = this.state.bprice;
    }
    const { errors } = this.state;
    const { user } = this.props.auth;
    return (
      <div className="col-md-12 tab-pane  active" id="buy_tab" >
        {/* onSubmit={()=>this.onOrderUpdate()} */}
        <form noValidate onSubmit={this.onOrderUpdate} id="update-user">
          <input onChange={this.onChange} value={this.state.user_id} id="user-update-id"
            type="text" className="d-none" />
          <div className="crypt-buy-sell-form">
            <div className="crypt-buy">
            {this.state.contestType==='coin' &&
              <div className="predict-outer">
                 <span className="text-status">
                 {/* Predict the contest from {this.state.startDate} to {this.state.endDate} and the results will declare at {this.state.priceDistributionDateTime} */}
                 Contest ends at {moment(this.state.endDate).format("DD-MM-YYYY hh:mm a")}.<br/>
                 Predict the coin price for {moment(this.state.priceDistributionDateTime).format("DD-MM-YYYY hh:mm a")}.
                  </span>                            
              </div>  
            }        
                           
              <div className="input-group mb-3">
                <div className="input-group-prepend"> <span
                  className="input-group-text">Current price</span> </div>
                <input id="bprice"
                  type={this.state.orrderExecuteType!=="market"?"number":"text"} className="form-control" value={pricess} placeholder="0.00" onKeyDown={this.handleKeyDown} onKeyUp={this.handleKeyUp} disabled="true"/>
                <span className="text-danger">{errors.bprice}</span>
                <div className="input-group-append"> <span
                  className="input-group-text">USDT</span> </div>
              </div>
              <div className="input-group mb-3">
                <div className="input-group-prepend"> <span
                  className="input-group-text">Coin Name</span> </div>
                <input onChange={this.onChange} id="coinName"
                  type="text" className="form-control" value={this.props.match.params.symbol.replace("-", "").slice(0, -4)} placeholder="0.00" onKeyDown={this.handleKeyDown} onKeyUp={this.handleKeyUp} disabled="true"/>
                <span className="text-danger">{errors.coinName}</span>
                <div className="input-group-append"> <span
                  className="input-group-text">{this.props.match.params.symbol.replace("-", "").slice(0, -4)}</span> </div>
              </div>
              {this.state.contestType==='coin' && 
                <div className="input-group mb-3">
                  <div className="input-group-prepend"> <span
                    className="input-group-text">Prediction Price</span> </div>
                  <input onChange={this.onChange} id="pridictionUserPrice"
                    type="number" className="form-control" value={this.state.pridictionUserPrice} placeholder="0.00" />
                  <span className="text-danger">{errors.pridictionUserPrice}</span>
                  <div className="input-group-append"> <span
                    className="input-group-text">USDT</span> </div>
                </div>
              }
              
                {this.state.contestType === 'price' &&
                  <div className="row">
                    <div className="col-6">
                     <button type="submit" disabled={this.state.orderPredictionData.length>0?true:false} className={this.state.orderPredictionData.length>0?'crypt-button-red-full btn-disabled':'crypt-button-red-full'} onClick={this.downBid} ><i class="las la-arrow-circle-down"></i> Down</button>
                    </div>
                    <div className="col-6">
                      <button type="submit" disabled={this.state.orderPredictionData.length>0?true:false} className={this.state.orderPredictionData.length>0?'crypt-button-green-full btn-disabled':'crypt-button-green-full'} onClick={this.upBid}><i class="las la-arrow-circle-up"></i> Up</button>
                    </div>
                  </div>
                }
                {this.state.contestType === 'coin' &&
                  <div className="row">
                      <button type="submit" className="crypt-button-green-full" >{this.state.orderPredictionData.length>0?"Modify":"Submit"}</button>
                  </div>
                }              
            </div>
          </div>
        </form>
        <Toaster position="bottom-right" reverseOrder={false} />
      </div>
    )
  }
}
PredictionBuyOrder.propTypes = {
  pridictionorder: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  orderdata: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  orderdata: state.orderdata,
  errors: state.errors
});
export default connect(
  mapStateToProps,
  { pridictionorder }
)(withRouter(PredictionBuyOrder));